export function getFallbackStateCustomers({ isLoading, allCustomers, filteredCustomers }) {
  if (isLoading) return { state: "loading" };

  if (!allCustomers || allCustomers.length === 0) {
    return { state: "noData" };
  }

  if (filteredCustomers.length === 0) {
    return { state: "noMatch" };
  }

  return { state: "ok" };
}
